import { Button, List, Modal, Typography } from "antd";
import WhatsappMessagePreview from "frontend-lib/Components/WhatsappMessagePreview/WhatsappMessagePreview";
import { Customer } from "frontend-lib/DomainTypes/Customer";
import { Template } from "frontend-lib/DomainTypes/Template";
import React from "react";
import { useTranslation } from "react-i18next";

const { Text, Paragraph } = Typography;

interface SendTemplateModalProps {
    selectedCustomer?: Customer;
    selectedTemplate?: Template;
    isVisible: boolean;
    setIsVisible: (visible: boolean) => void;
    handleSendTemplate: () => void;
}

export default function SendTemplateModal({
    selectedCustomer,
    selectedTemplate,
    isVisible,
    setIsVisible,
    handleSendTemplate,
}: SendTemplateModalProps) {
    const { t } = useTranslation();

    return (
        <Modal
            title={t("newMessages")}
            visible={isVisible}
            footer={
                <div>
                    <Button onClick={() => setIsVisible(false)}>{t("cancel")}</Button>
                    <Button type="primary" onClick={handleSendTemplate}>
                        {t("send")}
                    </Button>
                </div>
            }
            onCancel={() => setIsVisible(false)}
        >
            <List>
                <List.Item>
                    <Typography>
                        <Text type="secondary">{t("customer")}</Text>
                        <Paragraph>{selectedCustomer?.name}</Paragraph>
                    </Typography>
                </List.Item>
                <List.Item>
                    <Typography>
                        <Text type="secondary">{t("phone")}</Text>
                        <Paragraph>{selectedCustomer?.phone}</Paragraph>
                    </Typography>
                </List.Item>
                <List.Item>
                    <Typography>
                        <Text type="secondary">{t("outbound.templateName")}</Text>
                        <Paragraph>{selectedTemplate?.name}</Paragraph>
                    </Typography>
                </List.Item>
                <List.Item>
                    <Typography style={{ width: "100%" }}>
                        <Text type="secondary">{t("messageToSend")}</Text>
                        <WhatsappMessagePreview
                            values={{
                                templateBodyExample: selectedTemplate?.text || "",
                                phoneNumberButtonText: selectedTemplate?.buttons?.find(
                                    (b) => b.type === "PHONE_NUMBER"
                                )?.text,
                                urlButtonText: selectedTemplate?.buttons?.find(
                                    (b) => b.type === "URL"
                                )?.text,
                                quickReplyButton: selectedTemplate?.buttons?.find(
                                    (b) => b.type === "QUICK_REPLY"
                                )?.text,
                            }}
                            fileUrl={selectedTemplate?.file?.url}
                        />
                    </Typography>
                </List.Item>
            </List>
        </Modal>
    );
}
